import styles from "../../../styles/components/parts/view/PartsViewPc.module.css";
import buttonStyles from "../../../styles/components/asset/requestButton.module.css";
import { periodNoDiv } from "../../../components/search";
import { packagingLabel, CUSTOM_REEL_LABEL } from "../../common/packaging";
import Head from "next/head";
import { useState } from "react";
import NameCopy from "../../mypageNew/common/nameCopy";

export default function PartsViewPc(props) {
  const {
    //상태
    item_data,
    item_info,
    item_code,
    it_name,
    it_basic,
    prices,
    multiple,
    min_qty,
    max_qty,
    unit_price,
    userType,
    manufacturer,
    manufacturer_str,
    it_maker,
    origin_pn,
    lifeCycle,
    packaging,
    hs_code,
    logistic_weather,
    banners,
    banners_mobile,
    bannerIndex,
    total_price,
    total_price_vat,
    // 커스텀 릴 옵션
    reel_option,
    isReelSelected,
    setIsReelSelected,
    can_toggle_reel,
    chooseReel,
    display_packaging,
    show_packaging,
    display_prices,
    display_item_code,
    display_origin_pn,
    display_datasheet,
    display_max_qty,
    display_min_qty,
    display_multiple,
    display_min_price,
    order_total_price,
    partner,
    isWish,
    it_id,
    is_stock,
    total_qty,
    originalPrice,
    salePrice,
    desiredValue,
    desiredPrice,
    // 기능
    goToDatasheet,
    handleMinus,
    handlePlus,
    lifecycleNew,
    check_vat,
    handleMinQtyChange,
    handleMinQtyChangeFoucsOut,
    _addWish,
    _removeWish,
    _AddCart,
    isNullPacakageCheck,
    setDesiredValue,
    setDesiredPrice,
    requestEstimate,
  } = props;

  // 릴을 고르지 않았을 때의 포장 이름.
  // 릴 주소로 바로 들어온 경우엔 지금 행이 릴이므로, 되돌아갈 형제(컷테이프 등)의 이름을 보여준다.
  const base_packaging_label =
    reel_option && reel_option.is_reel
      ? reel_option.base && reel_option.base.packaging
      : packaging;

  return (
    <>
      <Head>
        <title>{it_name}</title>
      </Head>
      <div className={styles.frame0}>
        <div className={styles.detailTotalGroup}></div>
        <div className={styles.detailInfoInputGroup}>
          <div className={styles.detailInfo}>
            <div className={styles.infoBox}>
              <div className={styles.imageGroup}>
                <div className={styles.imageOutFrame}>
                  <div className={styles.imageBox}>
                    {item_info?.it_img1?.trim() ? (
                      <img
                        src={item_info.it_img1}
                        alt="image"
                        className={styles.image}
                        onError={(e) => {
                          e.target.src = "/images/noimageKO.jpg";
                        }}
                      />
                    ) : (
                      <img
                        src="/images/noimageKO.jpg"
                        alt="이미지 준비중"
                        className={styles.image}
                      />
                    )}
                  </div>
                </div>
                {display_datasheet ? (
                  <>
                    <div
                      className={`${styles.buttonFillWhite} ${styles.cursorActive}`}
                      onClick={() => goToDatasheet(display_datasheet)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M13.3538 5.14625L9.85375 1.64625C9.80728 1.59983 9.75212 1.56303 9.69143 1.53793C9.63073 1.51284 9.56568 1.49995 9.5 1.5H3.5C3.23478 1.5 2.98043 1.60536 2.79289 1.79289C2.60536 1.98043 2.5 2.23478 2.5 2.5V13.5C2.5 13.7652 2.60536 14.0196 2.79289 14.2071C2.98043 14.3946 3.23478 14.5 3.5 14.5H12.5C12.7652 14.5 13.0196 14.3946 13.2071 14.2071C13.3946 14.0196 13.5 13.7652 13.5 13.5V5.5C13.5001 5.43432 13.4872 5.36927 13.4621 5.30858C13.437 5.24788 13.4002 5.19272 13.3538 5.14625ZM9.85375 10.3538L8.35375 11.8538C8.30731 11.9002 8.25217 11.9371 8.19147 11.9623C8.13077 11.9874 8.06571 12.0004 8 12.0004C7.93429 12.0004 7.86923 11.9874 7.80853 11.9623C7.74783 11.9371 7.69269 11.9002 7.64625 11.8538L6.14625 10.3538C6.05243 10.2599 5.99972 10.1327 5.99972 10C5.99972 9.86732 6.05243 9.74007 6.14625 9.64625C6.24007 9.55243 6.36732 9.49972 6.5 9.49972C6.63268 9.49972 6.75993 9.55243 6.85375 9.64625L7.5 10.2931V7.5C7.5 7.36739 7.55268 7.24021 7.64645 7.14645C7.74021 7.05268 7.86739 7 8 7C8.13261 7 8.25979 7.05268 8.35355 7.14645C8.44732 7.24021 8.5 7.36739 8.5 7.5V10.2931L9.14625 9.64625C9.24007 9.55243 9.36732 9.49972 9.5 9.49972C9.63268 9.49972 9.75993 9.55243 9.85375 9.64625C9.94757 9.74007 10.0003 9.86732 10.0003 10C10.0003 10.1327 9.94757 10.2599 9.85375 10.3538ZM9.5 5.5V2.75L12.25 5.5H9.5Z"
                          fill="#2F2F2F"
                        />
                      </svg>
                      <div className={`${styles.datasheet} body1`}>
                        데이터시트
                      </div>
                    </div>
                  </>
                ) : (
                  <div
                    className={`${styles.buttonFillWhite} ${styles.datasheetDisable}`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M13.3538 5.14625L9.85375 1.64625C9.80728 1.59983 9.75212 1.56303 9.69143 1.53793C9.63073 1.51284 9.56568 1.49995 9.5 1.5H3.5C3.23478 1.5 2.98043 1.60536 2.79289 1.79289C2.60536 1.98043 2.5 2.23478 2.5 2.5V13.5C2.5 13.7652 2.60536 14.0196 2.79289 14.2071C2.98043 14.3946 3.23478 14.5 3.5 14.5H12.5C12.7652 14.5 13.0196 14.3946 13.2071 14.2071C13.3946 14.0196 13.5 13.7652 13.5 13.5V5.5C13.5001 5.43432 13.4872 5.36927 13.4621 5.30858C13.437 5.24788 13.4002 5.19272 13.3538 5.14625ZM9.85375 10.3538L8.35375 11.8538C8.30731 11.9002 8.25217 11.9371 8.19147 11.9623C8.13077 11.9874 8.06571 12.0004 8 12.0004C7.93429 12.0004 7.86923 11.9874 7.80853 11.9623C7.74783 11.9371 7.69269 11.9002 7.64625 11.8538L6.14625 10.3538C6.05243 10.2599 5.99972 10.1327 5.99972 10C5.99972 9.86732 6.05243 9.74007 6.14625 9.64625C6.24007 9.55243 6.36732 9.49972 6.5 9.49972C6.63268 9.49972 6.75993 9.55243 6.85375 9.64625L7.5 10.2931V7.5C7.5 7.36739 7.55268 7.24021 7.64645 7.14645C7.74021 7.05268 7.86739 7 8 7C8.13261 7 8.25979 7.05268 8.35355 7.14645C8.44732 7.24021 8.5 7.36739 8.5 7.5V10.2931L9.14625 9.64625C9.24007 9.55243 9.36732 9.49972 9.5 9.49972C9.63268 9.49972 9.75993 9.55243 9.85375 9.64625C9.94757 9.74007 10.0003 9.86732 10.0003 10C10.0003 10.1327 9.94757 10.2599 9.85375 10.3538ZM9.5 5.5V2.75L12.25 5.5H9.5Z"
                        fill="#2F2F2F"
                      />
                    </svg>
                    <div className={`${styles.datasheet} body1`}>
                      데이터시트
                    </div>
                  </div>
                )}
                <div className={`${styles.text} caption2`}>
                  참고용 이미지는 실제 제품과 다를 수 있습니다.<br></br> 정확한
                  사양은 데이터시트에서 확인하세요.
                </div>
              </div>
              <div className={styles.productInfoDetailGroup}>
                <div className={styles.productInfoBox}>
                  <div className={styles.productInfo}>
                    <div className={styles.productNumberOutFrame}>
                      <div className={`${styles.productNumber} caption2`}>
                        {display_item_code}
                      </div>
                    </div>
                    <div className={styles.productNameSummaryGroup}>
                      <div className={styles.productNameGroup}>
                        <div className={`${styles.productName} title2`}>
                          {it_name}
                        </div>
                        <NameCopy it_name={it_name} />
                      </div>
                      <div className={`${styles.summary} body4`}>
                        {" "}
                        {it_basic
                          ? it_basic.length > 65
                            ? `${it_basic.slice(0, 65)}...`
                            : it_basic
                          : it_basic}
                      </div>
                    </div>
                  </div>
                  <div className={styles.deliveryBox}>
                    <div className={`${styles.price} title2`}>
                      <span>{display_min_price.toLocaleString()}원</span>
                    </div>
                    <div className={styles.deliveryDate}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M15.4644 6.8125L14.5894 4.625C14.5151 4.43982 14.3869 4.28123 14.2214 4.16978C14.0559 4.05834 13.8608 3.99919 13.6613 4H11.5V3.5C11.5 3.36739 11.4473 3.24021 11.3536 3.14645C11.2598 3.05268 11.1326 3 11 3H1.5C1.23478 3 0.98043 3.10536 0.792893 3.29289C0.605357 3.48043 0.5 3.73478 0.5 4V11C0.5 11.2652 0.605357 11.5196 0.792893 11.7071C0.98043 11.8946 1.23478 12 1.5 12H2.5625C2.67265 12.4302 2.92285 12.8115 3.27366 13.0838C3.62446 13.3561 4.05591 13.5039 4.5 13.5039C4.94409 13.5039 5.37554 13.3561 5.72635 13.0838C6.07715 12.8115 6.32735 12.4302 6.4375 12H9.5625C9.67265 12.4302 9.92285 12.8115 10.2737 13.0838C10.6245 13.3561 11.0559 13.5039 11.5 13.5039C11.9441 13.5039 12.3755 13.3561 12.7263 13.0838C13.0771 12.8115 13.3273 12.4302 13.4375 12H14.5C14.7652 12 15.0196 11.8946 15.2071 11.7071C15.3946 11.5196 15.5 11.2652 15.5 11V7C15.5001 6.93581 15.488 6.87219 15.4644 6.8125ZM4.5 12.5C4.30222 12.5 4.10888 12.4414 3.94443 12.3315C3.77998 12.2216 3.65181 12.0654 3.57612 11.8827C3.50043 11.7 3.48063 11.4989 3.51921 11.3049C3.5578 11.1109 3.65304 10.9327 3.79289 10.7929C3.93275 10.653 4.11093 10.5578 4.30491 10.5192C4.49889 10.4806 4.69996 10.5004 4.88268 10.5761C5.06541 10.6518 5.22159 10.78 5.33147 10.9444C5.44135 11.1089 5.5 11.3022 5.5 11.5C5.5 11.7652 5.39464 12.0196 5.20711 12.2071C5.01957 12.3946 4.76522 12.5 4.5 12.5ZM1.5 8V4H10.5V8H1.5ZM11.5 12.5C11.3022 12.5 11.1089 12.4414 10.9444 12.3315C10.78 12.2216 10.6518 12.0654 10.5761 11.8827C10.5004 11.7 10.4806 11.4989 10.5192 11.3049C10.5578 11.1109 10.653 10.9327 10.7929 10.7929C10.9327 10.653 11.1109 10.5578 11.3049 10.5192C11.4989 10.4806 11.7 10.5004 11.8827 10.5761C12.0654 10.6518 12.2216 10.78 12.3315 10.9444C12.4414 11.1089 12.5 11.3022 12.5 11.5C12.5 11.7652 12.3946 12.0196 12.2071 12.2071C12.0196 12.3946 11.7652 12.5 11.5 12.5ZM11.5 6.5V5H13.6613L14.2612 6.5H11.5Z"
                          fill="#7D8593"
                        />
                      </svg>
                      <div className={`${styles.minmumCnt} caption2`}>
                        3,000원 (50,000원 이상 무료배송)
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.productDetail}>
                  <div className={styles.productDetailInfo}>
                    <div className={`${styles.productTitle} body4`}>제조사</div>
                    <div className={`${styles.productContents} body3`}>
                      {manufacturer_str}
                    </div>
                  </div>
                  <div className={styles.productDetailInfo}>
                    <div className={`${styles.productTitle} body4`}>유통사</div>
                    <div className={`${styles.productContents} body3`}>
                      {it_maker.toUpperCase()}
                    </div>
                  </div>
                  <div className={styles.productDetailInfo}>
                    <div className={`${styles.productTitle} body4`}>MPN</div>
                    <div className={`${styles.productContents} body3`}>
                      {it_name}
                    </div>
                  </div>
                  <div className={styles.productDetailInfo}>
                    <div className={`${styles.productTitle} body4`}>SKU</div>
                    <div className={`${styles.productContents} body3`}>
                      {display_origin_pn}
                    </div>
                  </div>
                  <div className={styles.lifeCycle}>
                    <div className={`${styles.productTitle} body4`}>
                      Lifecycle
                    </div>
                    <div className={`${styles.productContents} body3`}>
                      <img
                        src={lifecycleNew(lifeCycle)}
                        className={styles.rectangle32}
                      ></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.pointSaleGroup}>
              <div className={`${styles.point} body4`}>
                <div className={`${styles.pointTitle} body4`}>적립</div>
                <div className={`${styles.pointContents} body4`}>
                  0.5% 포인트 추가 적립
                </div>
              </div>
              <div className={`${styles.sale} body4`}>
                <div className={`${styles.pointTitle} body4`}>혜택</div>
                <div className={`${styles.salesGroup}`}>
                  <div className={`${styles.saleTitle} body4`}>
                    첫 구매 <span className={styles.redText}>3%할인</span>{" "}
                    (쿠폰적용시)
                  </div>
                  <div className={`${styles.saleTitle} body4`}>
                    골드회원혜택가{" "}
                    <span className={styles.redText}>상시 2% 할인</span>
                  </div>
                </div>
              </div>
              <div className={`${styles.delivery} body4`}>
                <div className={`${styles.deliveryText} body4`}>배송</div>
                <div className={`${styles.deliveryGroup}`}>
                  <div className={`${styles.saleTitle} body4`}>
                    {logistic_weather.period_start} ~{" "}
                    {logistic_weather.period_end} 이내 출고 예정
                  </div>
                  <div className={`${styles.saleTitle} body4`}>
                    {`${logistic_weather.weather_str}`}{" "}
                    <img
                      style={{ display: "inline" }}
                      src={`/images/weather/${logistic_weather.weather_txt}.png`}
                      width="18px"
                    />
                  </div>
                  <div className={`${styles.saleTitle} body4`}>
                    배송비 3,000원 (50,000원 이상 무료)
                  </div>
                </div>
              </div>
              {hs_code && (
                <div className={`${styles.point} body4`}>
                  <div className={`${styles.pointTitle} body4`}>HS코드</div>
                  <div className={`${styles.pointContents} body4`}>
                    {hs_code}
                  </div>
                </div>
              )}
            </div>
            <div className={styles.bannerOutFrame}>
              <div
                className={[
                  styles.bannerOutFrameWrapper,
                  bannerIndex === 0 && styles.bg0,
                  bannerIndex === 1 && styles.bg1,
                  bannerIndex === 2 && styles.bg2,
                ]
                  .filter(Boolean)
                  .join(" ")}
              >
                <a
                  href="/board/board_view?no=80&type=notice"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={banners[bannerIndex]}
                    alt="banner"
                    className={`${styles.banner}  body1`}
                  />
                </a>
              </div>
            </div>
            <div className={styles.noticeGroup}>
              <div className={styles.deliveryNotice}>
                <div className={`${styles.deliveryNoticehedline} body1`}>
                  배송안내
                </div>
                <div className={`${styles.deliveryNoticeBody}`}>
                  <div className={`${styles.deliveryNoticeBodyTitle} body4`}>
                    배송비
                  </div>
                  <div
                    className={`${styles.deliveryNoticeBodyContent} caption2`}
                  >
                    제주도 및 기타 섬지역은 항공료 및 선박료가 추가 될 수
                    있습니다. <br></br>또한 제품의 무게 및 크기에 따라 추가
                    배송비가 발생될 수 있으니, 이점 양해 바랍니다.
                  </div>
                </div>
                <div className={`${styles.deliveryNoticeBody}`}>
                  <div className={`${styles.deliveryNoticeBodyTitle} body4`}>
                    배송기간
                  </div>
                  <div
                    className={`${styles.deliveryNoticeBodyContent} caption2`}
                  >
                    당일 해외 발주 마감은 유통사 15시 / 17시로 나누어 2회 발주를
                    진행합니다. <br></br>평균적으로 국내재고 상품은 입금 후
                    2~3일, 해외재고는 입금 확인 후 3~15일이내 출고 됩니다.{" "}
                    <br></br>(도서 산간 지역은 1~2일 더 소요될 수 있습니다.){" "}
                    <br></br>예상 출고일이상 배송지연이 발생시 배송지연 보상을
                    해드립니다. <br></br> 단, 금요일 17시 이후 입금건은 월요일에
                    주문처리 됩니다. <br></br>휴일 주문(토/일, 법정공휴일)의
                    경우 다음 영업일에 상품준비가 이루어집니다. <br></br>
                  </div>
                </div>
                <div className={`${styles.deliveryNoticeBody}`}>
                  <div className={`${styles.deliveryNoticeBodyTitle} body4`}>
                    배송방법
                  </div>
                  <div
                    className={`${styles.deliveryNoticeBodyContent} caption2`}
                  >
                    택배 - 로젠택배(1588-9988)<br></br>(발송 후 평균 1~2일 내
                    수령가능하며, 택배사의 사정에 따라 다소 지연 될 수
                    있습니다.)
                    <br></br>
                    퀵서비스 - 퀵서비스는 구매자 부담 (착불) 입니다. <br></br>
                    퀵서비스는 서울/경기 일부 지역에서 가능합니다. 기타 화물등의
                    배송은 지원하지 않습니다.
                  </div>
                </div>
                <div className={`${styles.deliveryNoticeBody}`}>
                  <div className={`${styles.deliveryNoticeBodyTitle} body4`}>
                    통관 및 관세
                  </div>
                  <div
                    className={`${styles.deliveryNoticeBodyContent} caption2`}
                  >
                    해외 재고 상품의 수입 및 통관 절차는 판다파츠가 통합
                    관리하여 진행합니다.
                    <br></br>
                    번거로운 통관 확인 절차없이, 빠르고 편리하게 주문하실 수
                    있습니다.
                    <br></br>
                    단, 품목에 따라 관세가 발생할 수 있으며, 출고 전 관세 납부를
                    요청드릴 수 있습니다.
                  </div>
                </div>
              </div>
              <div className={styles.deliveryNotice}>
                <div className={`${styles.deliveryNoticehedline} body1`}>
                  교환/환불 안내
                </div>
                <div className={`${styles.deliveryNoticeBody}`}>
                  <div className={`${styles.deliveryNoticeBodyTitle} body4`}>
                    20일 교환/환불
                  </div>
                  <div
                    className={`${styles.deliveryNoticeBodyContent} caption2`}
                  >
                    제품 수령 후 20일이내에 다음과 같은 사항이 발생된 경우에
                    교환이 가능합니다.<br></br>
                    배송된 제품에 하자가 있거나, 기능상 문제가 발생한 경우
                    <br></br>
                    해외 재고 주문 상품은 상품의 하자가 아닌 경우(단순변심, 주문
                    실수)에 환불/취소가 불가능합니다.(해당 유통사 정책)<br></br>
                    주문 스펙 및 커팅, 릴제조 상품의 경우 교환/반품이 되지
                    않습니다.<br></br>
                    ESD에 민감한 부품은 환불이 불가 할 수도 있습니다.<br></br>
                    해외 주문 상품은 반품 시 해외 배송비 (4만원)가 부과될 수
                    있습니다.<br></br>
                    견적을 통해 별도로 구입한 물품은 구매 취소 및 반품이 불가 할
                    수 있습니다.<br></br>
                    Mil-Spec제품은 취소 및 반품이 불가능합니다.<br></br>
                    사전에 ‘취소 불가 / 반품 불가’로 지정된 부품은 반품 환불
                    불가<br></br>
                    제조사에서 보증하는 반품은 제조사 보증 및 반품/교환 조건의
                    정책에 따라 다릅니다.<br></br>
                    기술 지원은 제품 특성에 따라 제조사 또는 유통사로 직접
                    문의해야 할 수도 있습니다.<br></br>
                    Chip Outpost 제품으로 지정된 부품은 반품할 수 없습니다.
                    <br></br>
                    불가항력 : 제품 분배, 원자재 부족, 노동 쟁의, 운송 지연,
                    예상치 못한 상황, 천재지변, 제3자의 작위 또는 부작위, 행정
                    또는 군사 당국의 작위 또는 부작위, 정부의 우선순위, 화재,
                    파업, 홍수, 악천후, 컴퓨터 고장, 테러, 전염병, 격리 규제,
                    폭동 또는 전쟁 등을 포함하되 이에 국한되지 않고 합리적인
                    통제를 벗어나는 이유로 인한 배송 지연 또는 의무 불이행에
                    대해 배상책임을 지지 않습니다.<br></br>
                  </div>
                </div>
                <div className={`${styles.deliveryNoticeBody}`}>
                  <div className={`${styles.deliveryNoticeBodyTitle} body4`}>
                    기타
                  </div>
                  <div
                    className={`${styles.deliveryNoticeBodyContent} caption2`}
                  >
                    교환의 경우 로젠택배를 통해서 반품해 주셔야 합니다.{" "}
                    <br></br>타 택배와 착불로 교환/반품 요청시 통보 없이
                    반송처리 됩니다.
                    <br></br>
                    모든 제품은 공급사의 사정에 따라 단가변동 및 재고 소진이
                    발생 될수 있습니다.<br></br> 급작스러운 환율 변동에 의해
                    추가 금액을 요청 할수 도 있으니, 양해바랍니다.<br></br>{" "}
                    제품의 사용법등의 문의는 제조사에 직접 문의를 해야합니다.
                    <br></br>
                    판다파츠는 글로벌 공식 유통사와 제조사의 API를 통해 구매를
                    안전하고 간편하게 지원하는 서비스입니다.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.customerInput}>
            <div className={styles.numberPurchaseControlGroup}>
              <div className={styles.numberbox}>
                <div className={styles.inventoryGroup}>
                  <div className={styles.iconCubeGroup}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                    >
                      <path
                        d="M24.465 7.23499L14.84 1.96859C14.5828 1.82649 14.2938 1.75195 14 1.75195C13.7062 1.75195 13.4172 1.82649 13.16 1.96859L3.535 7.23718C3.26013 7.38758 3.03068 7.60901 2.8706 7.87836C2.71053 8.14772 2.62571 8.4551 2.625 8.76843V19.2291C2.62571 19.5424 2.71053 19.8498 2.8706 20.1191C3.03068 20.3885 3.26013 20.6099 3.535 20.7603L13.16 26.0289C13.4172 26.171 13.7062 26.2455 14 26.2455C14.2938 26.2455 14.5828 26.171 14.84 26.0289L24.465 20.7603C24.7399 20.6099 24.9693 20.3885 25.1294 20.1191C25.2895 19.8498 25.3743 19.5424 25.375 19.2291V8.76952C25.3749 8.45564 25.2903 8.14757 25.1302 7.87759C24.9701 7.60761 24.7404 7.38566 24.465 7.23499ZM14 13.1248L5.21172 8.31234L14 3.49984L22.7883 8.31234L14 13.1248ZM14.875 24.023V14.6375L23.625 9.84906V19.2291L14.875 24.023Z"
                        fill="white"
                      />
                    </svg>

                    <div className={`${styles.stockText} caption1`}>재고</div>
                  </div>
                  <div className={`${styles.stockCount} body1`}>
                    {display_max_qty.toLocaleString()}개
                  </div>
                </div>
                <div className={styles.moqGroup}>
                  <div className={styles.iconArrowsInGroup}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                    >
                      <path
                        d="M15.75 11.375V7C15.7499 6.82684 15.8011 6.65753 15.8972 6.51351C15.9934 6.36949 16.1301 6.25724 16.2901 6.19095C16.45 6.12467 16.6261 6.10734 16.7959 6.14116C16.9657 6.17498 17.1217 6.25843 17.2441 6.38094L18.8125 7.95047L22.1309 4.63094C22.2951 4.46675 22.5178 4.37451 22.75 4.37451C22.9822 4.37451 23.2049 4.46675 23.3691 4.63094C23.5332 4.79512 23.6255 5.0178 23.6255 5.25C23.6255 5.48219 23.5332 5.70488 23.3691 5.86906L20.0495 9.1875L21.6191 10.7559C21.7416 10.8783 21.825 11.0343 21.8588 11.2041C21.8927 11.3739 21.8753 11.55 21.809 11.7099C21.7428 11.8699 21.6305 12.0066 21.4865 12.1028C21.3425 12.1989 21.1732 12.2501 21 12.25H16.625C16.3929 12.25 16.1704 12.1578 16.0063 11.9937C15.8422 11.8296 15.75 11.6071 15.75 11.375ZM11.375 15.75H7C6.82684 15.7499 6.65753 15.8011 6.51351 15.8972C6.36949 15.9934 6.25724 16.1301 6.19095 16.2901C6.12467 16.45 6.10734 16.6261 6.14116 16.7959C6.17498 16.9657 6.25843 17.1217 6.38094 17.2441L7.95047 18.8125L4.63094 22.1309C4.46675 22.2951 4.37451 22.5178 4.37451 22.75C4.37451 22.9822 4.46675 23.2049 4.63094 23.3691C4.79512 23.5332 5.0178 23.6255 5.25 23.6255C5.48219 23.6255 5.70488 23.5332 5.86906 23.3691L9.1875 20.0495L10.7559 21.6191C10.8783 21.7416 11.0343 21.825 11.2041 21.8588C11.3739 21.8927 11.55 21.8753 11.7099 21.809C11.8699 21.7428 12.0066 21.6305 12.1028 21.4865C12.1989 21.3425 12.2501 21.1732 12.25 21V16.625C12.25 16.3929 12.1578 16.1704 11.9937 16.0063C11.8296 15.8422 11.6071 15.75 11.375 15.75ZM11.7097 6.19172C11.5498 6.12539 11.3739 6.10797 11.2041 6.14165C11.0343 6.17533 10.8784 6.25861 10.7559 6.38094L9.1875 7.95047L5.86906 4.63094C5.70488 4.46675 5.48219 4.37451 5.25 4.37451C5.0178 4.37451 4.79512 4.46675 4.63094 4.63094C4.46675 4.79512 4.37451 5.0178 4.37451 5.25C4.37451 5.48219 4.46675 5.70488 4.63094 5.86906L7.95047 9.1875L6.38094 10.7559C6.25843 10.8783 6.17498 11.0343 6.14116 11.2041C6.10734 11.3739 6.12467 11.55 6.19095 11.7099C6.25724 11.8699 6.36949 12.0066 6.51351 12.1028C6.65753 12.1989 6.82684 12.2501 7 12.25H11.375C11.6071 12.25 11.8296 12.1578 11.9937 11.9937C12.1578 11.8296 12.25 11.6071 12.25 11.375V7C12.25 6.82694 12.1986 6.65778 12.1024 6.51391C12.0063 6.37003 11.8696 6.25791 11.7097 6.19172ZM20.0495 18.8125L21.6191 17.2441C21.7416 17.1217 21.825 16.9657 21.8588 16.7959C21.8927 16.6261 21.8753 16.45 21.809 16.2901C21.7428 16.1301 21.6305 15.9934 21.4865 15.8972C21.3425 15.8011 21.1732 15.7499 21 15.75H16.625C16.3929 15.75 16.1704 15.8422 16.0063 16.0063C15.8422 16.1704 15.75 16.3929 15.75 16.625V21C15.7499 21.1732 15.8011 21.3425 15.8972 21.4865C15.9934 21.6305 16.1301 21.7428 16.2901 21.809C16.45 21.8753 16.6261 21.8927 16.7959 21.8588C16.9657 21.825 17.1217 21.7416 17.2441 21.6191L18.8125 20.0495L22.1309 23.3691C22.2122 23.4504 22.3087 23.5148 22.415 23.5588C22.5212 23.6028 22.635 23.6255 22.75 23.6255C22.865 23.6255 22.9788 23.6028 23.085 23.5588C23.1913 23.5148 23.2878 23.4504 23.3691 23.3691C23.4504 23.2878 23.5148 23.1913 23.5588 23.085C23.6028 22.9788 23.6255 22.865 23.6255 22.75C23.6255 22.635 23.6028 22.5212 23.5588 22.415C23.5148 22.3087 23.4504 22.2122 23.3691 22.1309L20.0495 18.8125Z"
                        fill="white"
                      />
                    </svg>

                    <div className={`${styles.stockText} caption1`}>
                      최소수량
                    </div>
                  </div>
                  <div className={`${styles.stockCount} body1`}>
                    {display_min_qty.toLocaleString()}개
                  </div>
                </div>
                <div className={styles.multipleGroup}>
                  <div className={styles.iconUnitsGroup}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                    >
                      <path
                        d="M9.1875 5.6875V10.0625H3.0625C2.94647 10.0625 2.83519 10.0164 2.75314 9.93436C2.67109 9.85231 2.625 9.74103 2.625 9.625V7C2.625 6.53587 2.80937 6.09075 3.13756 5.76256C3.46575 5.43437 3.91087 5.25 4.375 5.25H8.75C8.86603 5.25 8.97731 5.29609 9.05936 5.37814C9.14141 5.46019 9.1875 5.57147 9.1875 5.6875ZM10.9375 22.3125C10.9375 22.4285 10.9836 22.5398 11.0656 22.6219C11.1477 22.7039 11.259 22.75 11.375 22.75H16.625C16.741 22.75 16.8523 22.7039 16.9344 22.6219C17.0164 22.5398 17.0625 22.4285 17.0625 22.3125V17.9375H10.9375V22.3125ZM2.625 18.375V21C2.625 21.4641 2.80937 21.9092 3.13756 22.2374C3.46575 22.5656 3.91087 22.75 4.375 22.75H8.75C8.86603 22.75 8.97731 22.7039 9.05936 22.6219C9.14141 22.5398 9.1875 22.4285 9.1875 22.3125V17.9375H3.0625C2.94647 17.9375 2.83519 17.9836 2.75314 18.0656C2.67109 18.1477 2.625 18.259 2.625 18.375ZM2.625 12.25V15.75C2.625 15.866 2.67109 15.9773 2.75314 16.0594C2.83519 16.1414 2.94647 16.1875 3.0625 16.1875H9.1875V11.8125H3.0625C2.94647 11.8125 2.83519 11.8586 2.75314 11.9406C2.67109 12.0227 2.625 12.134 2.625 12.25ZM16.625 5.25H11.375C11.259 5.25 11.1477 5.29609 11.0656 5.37814C10.9836 5.46019 10.9375 5.57147 10.9375 5.6875V10.0625H17.0625V5.6875C17.0625 5.57147 17.0164 5.46019 16.9344 5.37814C16.8523 5.29609 16.741 5.25 16.625 5.25ZM24.9375 11.8125H18.8125V16.1875H24.9375C25.0535 16.1875 25.1648 16.1414 25.2469 16.0594C25.3289 15.9773 25.375 15.866 25.375 15.75V12.25C25.375 12.134 25.3289 12.0227 25.2469 11.9406C25.1648 11.8586 25.0535 11.8125 24.9375 11.8125ZM10.9375 16.1875H17.0625V11.8125H10.9375V16.1875ZM23.625 5.25H19.25C19.134 5.25 19.0227 5.29609 18.9406 5.37814C18.8586 5.46019 18.8125 5.57147 18.8125 5.6875V10.0625H24.9375C25.0535 10.0625 25.1648 10.0164 25.2469 9.93436C25.3289 9.85231 25.375 9.74103 25.375 9.625V7C25.375 6.53587 25.1906 6.09075 24.8624 5.76256C24.5342 5.43437 24.0891 5.25 23.625 5.25ZM24.9375 17.9375H18.8125V22.3125C18.8125 22.4285 18.8586 22.5398 18.9406 22.6219C19.0227 22.7039 19.134 22.75 19.25 22.75H23.625C24.0891 22.75 24.5342 22.5656 24.8624 22.2374C25.1906 21.9092 25.375 21.4641 25.375 21V18.375C25.375 18.259 25.3289 18.1477 25.2469 18.0656C25.1648 17.9836 25.0535 17.9375 24.9375 17.9375Z"
                        fill="white"
                      />
                    </svg>
                    <div className={`${styles.stockText} caption1`}>
                      구매단위
                    </div>
                  </div>
                  <div className={`${styles.stockCount} body1`}>
                    {display_multiple.toLocaleString()} 개
                  </div>
                </div>
              </div>
              <div className={styles.purchaseControlGroup}>
                <div className={styles.purchaseControlBox}>
                  {/* 배송 → 수량·패키징 → 주문금액 순서로 세 덩이를 구분선으로 나눈다 */}
                  <div className={styles.deliveryBoxRight}>
                    <div className={styles.deliveryDateGroup}>
                      <div className={`${styles.deliveryBoxRightText} body2`}>
                        배송기간
                      </div>
                      <div className={styles.deliveryDateRight}>
                        <div className={`${styles.totalPriceCnt} body3`}>
                          {periodNoDiv(partner)}
                          <span className={`body4`}>일</span>
                        </div>
                        <div className={styles.labelDelivery}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M11.2505 22.5005L8.25049 22.5005C8.05157 22.5005 7.86081 22.4215 7.72016 22.2808C7.5795 22.1402 7.50049 21.9494 7.50049 21.7505C7.50037 21.701 7.5054 21.6517 7.51549 21.6033L8.90674 14.6255L6.68205 14.6255L5.02736 16.2811C4.88751 16.4208 4.69816 16.4997 4.50049 16.5005L2.25049 16.5005C2.12757 16.5007 2.00648 16.4707 1.89788 16.4131C1.78928 16.3555 1.69649 16.2721 1.62769 16.1703C1.55888 16.0684 1.51617 15.9512 1.50331 15.829C1.49045 15.7067 1.50783 15.5832 1.55393 15.4692L2.94236 12.0005L1.55393 8.53174C1.50783 8.41779 1.49045 8.29425 1.50331 8.17201C1.51617 8.04976 1.55889 7.93255 1.62769 7.83069C1.69649 7.72883 1.78928 7.64544 1.89788 7.58786C2.00648 7.53028 2.12757 7.50028 2.25049 7.50049L4.50049 7.50049C4.59901 7.50041 4.69658 7.51974 4.78763 7.55739C4.87867 7.59503 4.96141 7.65024 5.03111 7.71986L6.6858 9.37549L8.90674 9.37549L7.51549 2.39768C7.5054 2.34927 7.50037 2.29994 7.50049 2.25049C7.50049 2.05158 7.5795 1.86081 7.72016 1.72016C7.86081 1.57951 8.05158 1.50049 8.25049 1.50049L11.2505 1.50049C11.3898 1.50039 11.5264 1.5391 11.645 1.6123C11.7636 1.68549 11.8594 1.79026 11.9217 1.91486L15.6511 9.37549L19.8755 9.37549C20.5717 9.37549 21.2394 9.65205 21.7316 10.1443C22.2239 10.6366 22.5005 11.3043 22.5005 12.0005C22.5005 12.6967 22.2239 13.3644 21.7316 13.8566C21.2394 14.3489 20.5717 14.6255 19.8755 14.6255L15.6511 14.6255L11.9217 22.0861C11.8594 22.2107 11.7636 22.3155 11.645 22.3887C11.5264 22.4619 11.3898 22.5006 11.2505 22.5005Z"
                              fill="#69A2FF"
                            />
                          </svg>
                          <div className={`${styles.globalText} label1`}>
                            해외
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${styles.rowDivider} ${styles.rowDividerBeforeOption}`}
                  ></div>
                  <div className={styles.orderOptionGroup}>
                    <div className={styles.selectQuantity}>
                      <div className={`${styles.selectQuantityText} body2`}>
                        수량
                      </div>
                      <div className={styles.numberInput}>
                        <div
                          className={
                            `${styles.buttonIcon} ` +
                            `${
                              display_min_qty !== total_qty
                                ? styles.cursorPointerActive
                                : ""
                            } ` +
                            `body2`
                          }
                          onClick={handleMinus}
                        >
                          {display_min_qty === total_qty ? (
                            // 연한 회색 아이콘
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M12.6666 7C13.2189 7 13.6666 7.44773 13.6666 8C13.6666 8.55227 13.2189 9 12.6666 9H3.33325C2.78097 9 2.33325 8.55227 2.33325 8C2.33325 7.44773 2.78097 7 3.33325 7H12.6666Z"
                                fill="#B6BCC9"
                              />
                            </svg>
                          ) : (
                            // 기존 아이콘 (짙은 색)
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M12.6668 7C13.2191 7 13.6668 7.44773 13.6668 8C13.6668 8.55227 13.2191 9 12.6668 9H3.3335C2.78121 9 2.3335 8.55227 2.3335 8C2.3335 7.44773 2.78121 7 3.3335 7H12.6668Z"
                                fill="#2F2F2F"
                              />
                            </svg>
                          )}
                        </div>
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="\d*"
                          className={`${styles.inputButton} body3`}
                          value={total_qty}
                          onChange={(e) => handleMinQtyChange(e.target.value)}
                          onBlur={(e) =>
                            handleMinQtyChangeFoucsOut(e.target.value)
                          }
                        />
                        <div
                          className={
                            `${styles.buttonIcon} ` +
                            `${
                              display_max_qty !== total_qty
                                ? styles.cursorPointerActive
                                : ""
                            } ` +
                            `headline2`
                          }
                          onClick={handlePlus}
                        >
                          {display_max_qty === total_qty ? (
                            // 연한 회색 아이콘
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M6.99992 12.6668V9.00016H3.33325C2.78097 9.00016 2.33325 8.55243 2.33325 8.00016C2.33325 7.4479 2.78097 7.00016 3.33325 7.00016H6.99992V3.3335C6.99992 2.78121 7.44765 2.3335 7.99992 2.3335C8.55219 2.3335 8.99992 2.78121 8.99992 3.3335V7.00016H12.6666C13.2189 7.00016 13.6666 7.4479 13.6666 8.00016C13.6666 8.55243 13.2189 9.00016 12.6666 9.00016H8.99992V12.6668C8.99992 13.2191 8.55219 13.6668 7.99992 13.6668C7.44765 13.6668 6.99992 13.2191 6.99992 12.6668Z"
                                fill="#B6BCC9"
                              />
                            </svg>
                          ) : (
                            // 기존 아이콘 (짙은 색)
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M6.99967 12.6668V9.00016H3.33301C2.78072 9.00016 2.33301 8.55243 2.33301 8.00016C2.33301 7.4479 2.78072 7.00016 3.33301 7.00016H6.99967V3.3335C6.99967 2.78121 7.44741 2.3335 7.99967 2.3335C8.55194 2.3335 8.99967 2.78121 8.99967 3.3335V7.00016H12.6663C13.2186 7.00016 13.6663 7.4479 13.6663 8.00016C13.6663 8.55243 13.2186 9.00016 12.6663 9.00016H8.99967V12.6668C8.99967 13.2191 8.55194 13.6668 7.99967 13.6668C7.44741 13.6668 6.99967 13.2191 6.99967 12.6668Z"
                                fill="#2F2F2F"
                              />
                            </svg>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* 패키징 줄은 디지키 상품에서만 (control-plane#13) */}
                    {show_packaging && (
                      <div className={styles.selectQuantity}>
                        <div className={`${styles.selectQuantityText} body2`}>
                          패키징
                        </div>
                        {/* 릴 형제가 있으면 고를 수 있게, 없으면 지금처럼 텍스트로.
                            고르는 자리를 주문금액 바로 위에 둬서 금액이 오르는 게 보이게 한다.
                            (control-plane#13 : 릴 수수료를 못 보고 넘어가던 것이 문제의 핵심) */}
                        {can_toggle_reel ? (
                          <select
                            className={`${styles.packagingSelect} body3`}
                            value={isReelSelected ? "reel" : "base"}
                            onChange={(e) =>
                              chooseReel(e.target.value === "reel")
                            }
                          >
                            <option value="base">
                              {isNullPacakageCheck(
                                packagingLabel(base_packaging_label)
                              )}
                            </option>
                            <option value="reel">
                              {CUSTOM_REEL_LABEL} (+
                              {reel_option.fee.toLocaleString()}원)
                            </option>
                          </select>
                        ) : (
                          <div className={`${styles.packagingStatic} body3`}>
                            {isNullPacakageCheck(
                              packagingLabel(display_packaging)
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div
                    className={`${styles.rowDivider} ${styles.rowDividerBeforePrice}`}
                  ></div>
                  <div className={styles.totalPriceGroup}>
                    <div className={`${styles.totalPriceCnt} body2`}>
                      주문금액{" "}
                    </div>
                    <div className={styles.totalPrice}>
                      <div className={`${styles.totalPriceCnt} body2`}>
                        <span className={`${styles.countRed} headline1`}>
                          <span>{order_total_price.toLocaleString()}원</span>{" "}
                        </span>
                      </div>
                      {/* 부가세 안내는 금액 바로 아래에 둔다.
                          위쪽 배송 영역에 두면 "주문금액" 라벨이 두 번 나와 겹쳐 보인다 */}
                      <div className={`${styles.totalPriceVat} body4`}>
                        부가세 10% 미포함
                      </div>
                    </div>
                  </div>
                  {/* 장바구니 담기 — 단독 풀폭 */}
                  <div className={styles.buttonGroup}>
                    <div
                      className={styles.buttonFillPrimary}
                      onClick={() => {
                        _AddCart(
                          it_id,
                          total_qty,
                          it_maker,
                          origin_pn,
                          packaging,
                          is_stock
                        );
                      }}
                    >
                      <div className={`${styles.cartIconText} body1`}>
                        장바구니 담기
                      </div>
                    </div>
                  </div>

                  {/* 단가정보 */}
                  <div
                    className={`${styles.selectQuantityGroup} ${styles.unitPriceGroup}`}
                  >
                    <div className={styles.selectQuantityheadline}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M11.5554 2.6665H4.44428C3.46244 2.6665 2.6665 3.46244 2.6665 4.44428V11.5554C2.6665 12.5372 3.46244 13.3332 4.44428 13.3332H11.5554C12.5372 13.3332 13.3332 12.5372 13.3332 11.5554V4.44428C13.3332 3.46244 12.5372 2.6665 11.5554 2.6665Z"
                          fill="#2F2F2F"
                        />
                      </svg>
                      <div className={`${styles.moqInformation} headline1`}>
                        단가정보
                      </div>
                    </div>
                    <div className={styles.selectQuantityBox}>
                      <div className={styles.quantityCostBoxGroup}>
                        {display_prices.length > 0
                          ? display_prices.map((el, idx) => {
                              // 내림차순 기준 → upper boundary = 앞 tier의 Quantity
                              const upperBound =
                                idx === 0
                                  ? Infinity
                                  : display_prices[idx - 1].Quantity;

                              const isActive =
                                total_qty >= el.Quantity &&
                                total_qty < upperBound;

                              return (
                                <div
                                  className={styles.quantityCostBox}
                                  key={el.Quantity}
                                >
                                  <div
                                    className={`${
                                      isActive
                                        ? styles.quantityCostBoxTextActive
                                        : styles.quantityCostBoxText
                                    } body1`}
                                  >
                                    {el.Quantity}+
                                  </div>

                                  <div className={styles.costGroup}>
                                    <div
                                      className={`${styles.costCancelText} body4`}
                                    >
                                      {userType === "affilate_member" ||
                                      userType === "discount_member"
                                        ? el.price_before.toLocaleString() +
                                          "원"
                                        : ""}
                                    </div>

                                    <div
                                      className={`${
                                        isActive
                                          ? styles.quantityCostBoxTextActive
                                          : styles.quantityCostBoxText
                                      } body1`}
                                    >
                                      {userType === "affilate_member" ||
                                      userType === "discount_member"
                                        ? el.Price.toLocaleString() + "원"
                                        : el.price_before.toLocaleString() +
                                          "원"}
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          : ""}

                        {/* 빨간색 표기 참고 */}
                        {/* <div className={styles.quantityCostBox}>
                        <div
                          className={`${styles.quantityCostBoxTextActive} headline3`}
                        >
                          200개+
                        </div>
                        <div className={styles.costGroup}>
                          <div className={`${styles.costCancelText} body2`}>
                            2,500원
                          </div>
                          <div
                            className={`${styles.quantityCostBoxTextActive} headline3`}
                          >
                            2,400원
                          </div>
                        </div>
                      </div> */}
                      </div>
                    </div>
                  </div>

                  {/* 회원혜택가 안내 — 단가정보 아래 */}
                  {userType === "affilate_member" ||
                  userType === "discount_member" ? (
                    <>
                      <div className={styles.sectionMessageAffiliate}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM7.5 5C7.5 4.86739 7.55268 4.74021 7.64645 4.64645C7.74022 4.55268 7.86739 4.5 8 4.5C8.13261 4.5 8.25979 4.55268 8.35356 4.64645C8.44732 4.74021 8.5 4.86739 8.5 5V8.5C8.5 8.63261 8.44732 8.75979 8.35356 8.85355C8.25979 8.94732 8.13261 9 8 9C7.86739 9 7.74022 8.94732 7.64645 8.85355C7.55268 8.75979 7.5 8.63261 7.5 8.5V5ZM8 11.5C7.85167 11.5 7.70666 11.456 7.58333 11.3736C7.45999 11.2912 7.36386 11.1741 7.30709 11.037C7.25033 10.9 7.23547 10.7492 7.26441 10.6037C7.29335 10.4582 7.36478 10.3246 7.46967 10.2197C7.57456 10.1148 7.7082 10.0433 7.85368 10.0144C7.99917 9.98547 8.14997 10.0003 8.28701 10.0571C8.42406 10.1139 8.54119 10.21 8.6236 10.3333C8.70602 10.4567 8.75 10.6017 8.75 10.75C8.75 10.9489 8.67098 11.1397 8.53033 11.2803C8.38968 11.421 8.19892 11.5 8 11.5Z"
                            fill="#69A2FF"
                          />
                        </svg>
                        <div className={`${styles.announcement} caption2`}>
                          <span className={`${styles.announcement} caption1`}>
                            일반회원가
                          </span>{" "}
                          보다{" "}
                          <span className={`${styles.titleColorBlue} caption1`}>
                            {(originalPrice - salePrice).toLocaleString()}원
                          </span>{" "}
                          더 할인되었습니다.
                        </div>{" "}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className={styles.sectionMessage}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM7.5 5C7.5 4.86739 7.55268 4.74021 7.64645 4.64645C7.74022 4.55268 7.86739 4.5 8 4.5C8.13261 4.5 8.25979 4.55268 8.35356 4.64645C8.44732 4.74021 8.5 4.86739 8.5 5V8.5C8.5 8.63261 8.44732 8.75979 8.35356 8.85355C8.25979 8.94732 8.13261 9 8 9C7.86739 9 7.74022 8.94732 7.64645 8.85355C7.55268 8.75979 7.5 8.63261 7.5 8.5V5ZM8 11.5C7.85167 11.5 7.70666 11.456 7.58333 11.3736C7.45999 11.2912 7.36386 11.1741 7.30709 11.037C7.25033 10.9 7.23548 10.7492 7.26441 10.6037C7.29335 10.4582 7.36478 10.3246 7.46967 10.2197C7.57456 10.1148 7.7082 10.0434 7.85368 10.0144C7.99917 9.98547 8.14997 10.0003 8.28701 10.0571C8.42406 10.1139 8.54119 10.21 8.6236 10.3333C8.70602 10.4567 8.75 10.6017 8.75 10.75C8.75 10.9489 8.67098 11.1397 8.53033 11.2803C8.38968 11.421 8.19892 11.5 8 11.5Z"
                            fill="#F7323F"
                          />
                        </svg>
                        <div className={`${styles.announcement} caption2`}>
                          <span className={`${styles.announcement} caption1`}>
                            회원혜택가
                          </span>{" "}
                          적용시{" "}
                          <span className={`${styles.titleColor} caption1`}>
                            {(originalPrice - salePrice).toLocaleString()}원
                          </span>{" "}
                          더 할인됩니다.
                        </div>{" "}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className={styles.customizedUnitBox}>
              <div className={styles.customizedUnitHeadline}>
                <div className={`${styles.needQuoteText} body3`}>
                  맞춤 단가가 필요하세요?
                </div>
                <div className={`${styles.needQuoteContent} caption2`}>
                  필요 수량과 희망 가격을 알려주시면, <br></br>
                  수량별 최적 단가로 특별 혜택을 안내해 드려요.
                </div>
              </div>
              <div className={styles.inputControl}>
                <div className={styles.inputGroup}>
                  {/* 필요수량 Input */}
                  <div className={styles.textInput}>
                    <div
                      className={`${styles.inputBoxNoHeader} ${styles.inputBoxActive}`}
                    >
                      <input
                        value={desiredValue}
                        onChange={(e) => setDesiredValue(e.target.value)}
                        type="number"
                        className={styles.customInput}
                        placeholder="필요수량"
                      />
                    </div>
                  </div>

                  {/* 희망가격 Input */}
                  <div className={styles.textInput}>
                    <div
                      className={`${styles.inputBoxNoHeader} ${styles.inputBoxActive}`}
                    >
                      <input
                        value={desiredPrice}
                        onChange={(e) => setDesiredPrice(e.target.value)}
                        type="number"
                        className={styles.customInput}
                        placeholder="희망가격"
                      />
                      <div
                        className={
                          desiredPrice
                            ? styles.wonActive // 값이 있을 때
                            : styles.won + // 값이 비었을 때
                              " body4"
                        }
                      >
                        원
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={buttonStyles.buttonGroup}
                  onClick={() =>
                    requestEstimate({
                      it_name,
                      manufacturer: manufacturer,
                    })
                  }
                >
                  {/* 🔥 견적 바로받기 버튼에 requestEstimate 연결 */}
                  <div className={buttonStyles.requestButton}>
                    <div className={buttonStyles.iconLightning}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M20.0484 11.7619L9.54838 23.0119C9.43711 23.1306 9.29023 23.21 9.12992 23.2379C8.9696 23.2659 8.80455 23.2409 8.65966 23.1668C8.51476 23.0928 8.3979 22.9736 8.3267 22.8272C8.2555 22.6809 8.23382 22.5154 8.26494 22.3556L9.63932 15.481L4.23651 13.4522C4.12047 13.4088 4.017 13.3373 3.93533 13.2442C3.85366 13.151 3.79633 13.0391 3.76847 12.9184C3.74062 12.7977 3.7431 12.6719 3.77569 12.5524C3.80828 12.4329 3.86998 12.3233 3.95526 12.2335L14.4553 0.983457C14.5665 0.86471 14.7134 0.785374 14.8737 0.757423C15.034 0.729473 15.1991 0.754423 15.344 0.828509C15.4889 0.902595 15.6057 1.0218 15.6769 1.16813C15.7481 1.31446 15.7698 1.47998 15.7387 1.63971L14.3606 8.52189L19.7634 10.5478C19.8786 10.5915 19.9812 10.6629 20.0622 10.7557C20.1433 10.8485 20.2002 10.9598 20.228 11.0798C20.2558 11.1998 20.2536 11.3248 20.2216 11.4438C20.1897 11.5628 20.1289 11.672 20.0446 11.7619H20.0484Z"
                          fill="white"
                        />
                      </svg>
                    </div>

                    <div className={`${buttonStyles.bodyiconLigthing} body3`}>
                      견적바로받기
                    </div>
                  </div>

                  <div className={buttonStyles.iconChevronRight}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.29289 3.29289C5.68342 2.90237 6.31643 2.90237 6.70696 3.29289L10.707 7.29289C10.8945 7.48043 10.9999 7.73471 10.9999 7.99992C10.9999 8.26514 10.8945 8.51942 10.707 8.70696L6.70696 12.707C6.31643 13.0975 5.68342 13.0975 5.29289 12.707C4.90237 12.3164 4.90237 11.6834 5.29289 11.2929L8.58586 7.99992L5.29289 4.70696C4.90237 4.31643 4.90237 3.68342 5.29289 3.29289Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
